"use client";

import React, { useState, useEffect } from 'react';
// import Image from 'next/image'; // Removed unused import
import Link from 'next/link'; // Re-added Link import
import { Button } from '@/components/ui/button';
import ctaConfig from '@/../config/ctaConfig.json'; // Only import CTA config

const CTASection = () => {
  const words = ["details", "updates", "questions", "action items"];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 2000); // Change every 2 seconds

    return () => clearInterval(interval);
  }, [words.length]);

  return (
    <div className="bg-gradient-to-b from-[#121212] via-[#0a2647] to-[#121212] text-white pt-16 md:pt-20 pb-28">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          {/* Removed the h2 heading */}
          {/* 
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Ready to Transform Your Meeting Experience?
          </h2>
          */}
          
          {/* Restructured text block with valid nesting */}
          <div className="text-5xl md:text-6xl font-bold text-white mb-10 max-w-4xl mx-auto">
            {/* Line 1: Use spans and inline-block div */}
            <div className="leading-tight"> {/* Wrapper div for line 1 */} 
              <span>Never miss any </span> 
              <div className="h-16 w-96 inline-block overflow-hidden align-middle mx-2"> 
                {/* Inner container for transform */}
                <div 
                  className="transition-transform duration-500 ease-in-out" 
                  style={{ transform: `translateY(-${currentWordIndex * 4.1}rem)` }}
                >
                  {words.map((word) => (
                    <div key={word} className="h-16 flex items-center"> 
                      <span className="text-blue-500 whitespace-nowrap">
                        {word}
                      </span>
                    </div>
                  ))}
                  {/* Duplicate first word */}
                  <div key={words[0]+"-clone"} className="h-16 flex items-center"> 
                    <span className="text-blue-500 whitespace-nowrap">
                      {words[0]}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* Line 2: Use span or p */} 
            <p className="leading-tight">from your meetings ever.</p> 
          </div>

          {/* Buttons - added items-center for mobile */}
          <div className="flex justify-center mt-10">
            {/* Standard Button for Book Demo with Link to contact page */}
            <Link 
              href={ctaConfig.homeCTA.bookDemoLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-full"
              >
                {ctaConfig.homeCTA.bookDemoText}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTASection; 